module.exports = __webpack_public_path__ + "img/gq7.f46241dc.png";